<template>
  <svg width="23" height="23" viewBox="0 0 23 23" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M9.58301 14.375L9.58301 11.5"
      stroke="url(#paint0_linear_2438_8182)"
      stroke-width="2"
      stroke-linecap="round"
      class="path"
    />
    <path
      d="M13.417 14.375L13.417 11.5"
      stroke="url(#paint1_linear_2438_8182)"
      stroke-width="2"
      stroke-linecap="round"
      class="path"
    />
    <path
      d="M2.875 6.70898H20.125V6.70898C19.3103 6.70898 18.903 6.70898 18.5762 6.8259C18.0124 7.02763 17.5686 7.47139 17.3669 8.0352C17.25 8.36195 17.25 8.7693 17.25 9.58398V15.1673C17.25 17.0529 17.25 17.9957 16.6642 18.5815C16.0784 19.1673 15.1356 19.1673 13.25 19.1673H9.75C7.86438 19.1673 6.92157 19.1673 6.33579 18.5815C5.75 17.9957 5.75 17.0529 5.75 15.1673V9.58398C5.75 8.76929 5.75 8.36195 5.63309 8.0352C5.43135 7.47139 4.9876 7.02763 4.42378 6.8259C4.09703 6.70898 3.68969 6.70898 2.875 6.70898V6.70898Z"
      stroke="url(#paint2_linear_2438_8182)"
      stroke-width="2"
      stroke-linecap="round"
      class="path"
    />
    <path
      d="M9.64897 3.23015C9.75817 3.12826 9.9988 3.03823 10.3335 2.97402C10.6683 2.90981 11.0784 2.875 11.5003 2.875C11.9222 2.875 12.3324 2.90981 12.6671 2.97402C13.0019 3.03823 13.2425 3.12826 13.3517 3.23015"
      stroke="url(#paint3_linear_2438_8182)"
      stroke-width="2"
      stroke-linecap="round"
      class="path"
    />
    <defs>
      <linearGradient
        id="paint0_linear_2438_8182"
        x1="9.58301"
        y1="12.9375"
        x2="10.583"
        y2="12.9375"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#437BE8" />
        <stop offset="1" stop-color="#0F8DFB" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_2438_8182"
        x1="13.417"
        y1="12.9375"
        x2="14.417"
        y2="12.9375"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#437BE8" />
        <stop offset="1" stop-color="#0F8DFB" />
      </linearGradient>
      <linearGradient
        id="paint2_linear_2438_8182"
        x1="11.5"
        y1="6.70898"
        x2="11.5"
        y2="19.1673"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#437BE8" />
        <stop offset="1" stop-color="#0F8DFB" />
      </linearGradient>
      <linearGradient
        id="paint3_linear_2438_8182"
        x1="11.5003"
        y1="2.875"
        x2="11.5003"
        y2="3.83333"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#437BE8" />
        <stop offset="1" stop-color="#0F8DFB" />
      </linearGradient>
    </defs>
  </svg>
</template>

<style scoped lang="scss">
@use "@/assets/scss/variables" as *;

.v-icon--disabled {
  svg {
    .path {
      stroke: $border-input;
    }
  }
}
.icon-delete {
  svg {
    .path {
      stroke: #df252a;
    }
  }
}
.btn-icon-trash {
  svg {
    width: 1.5rem;
    height: 1.5rem;
    .path {
      stroke: #ff6c69;
    }
  }
}
</style>
